module.exports = __webpack_public_path__ + "static/media/home_carousel_1.38295a76.png";